module.exports = __webpack_public_path__ + "img/none.3cf716c1.png";